import { render, staticRenderFns } from "./PartNumberAttachments.vue?vue&type=template&id=6ad0a836&scoped=true&"
import script from "./PartNumberAttachments.vue?vue&type=script&lang=js&"
export * from "./PartNumberAttachments.vue?vue&type=script&lang=js&"
import style0 from "./PartNumberAttachments.vue?vue&type=style&index=0&id=6ad0a836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0a836",
  null
  
)

export default component.exports